/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Create_Public_Threads_HintInputs */



/**
* | output |
* | --- |
* | "Allow members to create threads that everyone in a channel can view." |
*
* @param {Leveling_Perm_Create_Public_Threads_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_create_public_threads_hint = /** @type {((inputs?: Leveling_Perm_Create_Public_Threads_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Create_Public_Threads_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам создавать ветки, которые видны всем в канале.")
	return /** @type {LocalizedString} */ ("Allow members to create threads that everyone in a channel can view.")
});